import React from "react";
import ReactDOM from "react-dom";

import Dlg from "./dlg";
import { BsyUtils } from "../../utils/Utils";

const BsyMsgBubble = (props) =>
  new Promise((fulfill) => {
    // 此处参数需用圆括号，否则 eslint 报错
    if (
      document.getElementsByClassName("bsy-msg-bubble").length > 0 &&
      props.isAlone
    ) {
      BsyUtils.forEach(window.MsgBubbleContext, (key, val) => {
        val.onRemoveRoot();
      });
      window.MsgBubbleContext = {};
    }
    let holder;
    let rootTokenClass = "rootTokenCls" + new Date().getTime();
    holder = document.createElement("div");
    holder.style.zIndex = window.FX.STATIC.zIndex++;
    holder.classList.add("bsy-msg-bubble");
    holder.classList.add(rootTokenClass);
    if (props.customCls) {
      holder.classList.add(props.customCls);
    }

    if (props.theme) {
      holder.classList.add(props.theme);
    }
    if (props.minWidth) {
      if (props.minWidth === "auto") {
        holder.style.minWidth = 160 + "px";
      } else if (typeof props.minWidth === "number") {
        holder.style.minWidth = props.minWidth + "px;";
      } else {
        holder.style.minWidth = props.minWidth + "px;";
      }
    }

    window.MsgBubbleQueue = window.MsgBubbleQueue || [];
    window.MsgBubbleContext = window.MsgBubbleContext || {};

    window.MsgBubbleQueue = [rootTokenClass, ...window.MsgBubbleQueue];

    //判断是否点击到文档，如果是的，需要关闭全部浮动的窗口
    let isClickDocument = (e) => {
      var d = -1;
      for (let i = 0; i < window.MsgBubbleQueue.length; i++) {
        var tok = window.MsgBubbleQueue[i];
        if (BsyUtils.closestClass(e.target, tok)) {
          d = i;
        }
      }
      return d;
    };

    if (props.anchor) {
      let d = holder;
      let i,
        cd = 6;
      // eslint-disable-next-line no-unused-expressions
      props.hasTriangle &&
        ((cd = 8),
        (i = window.$('<div class="triangle-up"/>').appendTo(window.$(d))));
      let j = window.$(props.anchor).offset(),
        k =
          j.top +
          window.$(props.anchor).outerHeight(true) +
          cd -
          window.$("body").offset().top,
        l = {
          "z-index": window.FX.STATIC.zIndex++,
        },
        m = Math.min(props.edge, document.body.clientHeight / 2);
      // , m = //Math.min(props.edge, document.body.clientHeight / 2);
      if (props["marginTop"]) {
        l["marginTop"] = props["marginTop"];
      }

      if (document.body.clientHeight + document.body.scrollTop - k - 10 <= m) {
        l.top = "auto";
        l.bottom = document.body.clientHeight - j.top + 8; //(c.topOffset > 0 ? c.topOffset + 7 : c.topOffset),
        holder.classList.add("dock-bottom");
      } else {
        l.top = k; //(c.topOffset > 0 ? (c.topOffset + 5) : c.topOffset - 5),
        l.bottom = "auto";
        holder.classList.add("dock-top");
      }
      let n = props.hAdjust || 0;
      // eslint-disable-next-line default-case
      switch (props.dockPosition) {
        case "left":
          holder.classList.add("dock-left");
          // l.left = j.left + c.anchor.outerWidth() / 2 - cd - n;
          l.left = j.left + (props.leftOffset || 0);
          if (props.topOffset) {
            if (l.bottom === "auto") {
              l.top += props.topOffset;
            } else {
              l.bottom -= props.topOffset;
            }
          }
          if (BsyUtils.isNumber(props.width)) {
            if (props.width + l.left > document.body.clientWidth) {
              l.left =
                l.left -
                (props.width + l.left - document.body.clientWidth) -
                10;
            }
          } else if (BsyUtils.isNumber(props.minWidth)) {
            if (props.minWidth + l.left > document.body.clientWidth) {
              l.left =
                l.left -
                (props.minWidth + l.left - document.body.clientWidth) -
                10;
            }
          }

          i &&
            i.css({
              left: n,
            });
          break;
        case "right":
          holder.classList.add("dock-right");
          l.right =
            document.body.clientWidth -
            j.left -
            props.anchor.offsetWidth / 2 -
            cd -
            n -
            5;
          if (l.right < 0) {
            l.right = 5;
          }
          i &&
            i.css({
              right: n,
            });
          break;
        case "rightalign":
          holder.classList.add("dock-right");
          l.right =
            document.body.clientWidth - j.left - props.anchor.offsetWidth;
          if (l.right < 0) {
            l.right = 5;
          }
          i &&
            i.css({
              right: n,
            });
          break;
        case "center":
          holder.classList.add("dock-center");
          l.left =
            j.left +
            window.$(props.anchor).outerWidth(true) / 2 -
            props.anchor.offsetWidth / 2 -
            cd -
            n; //+ c.anchor.width() / 2 - 8 - n,
          // console.log(l, window.$(props.anchor).outerWidth(true), window.$("body").outerWidth(true), props)
          if (props.width) {
            if (l.left + props.width > window.$("body").outerWidth(true)) {
              l.left = window.$("body").outerWidth(true) - props.width;
            }
          }
          i &&
            i.css({
              left: n,
            });
          break;
      }

      window.$(d).css(l);
    }
    holder.classList.add("modal");
    holder.style.visibility = "hidden";
    props.height && (holder.style.height = props.height + "px");
    props.minHeight && (holder.style.minHeight = props.minHeight + "px");
    props.maxHeight && (holder.style.maxHeight = props.maxHeight + "px");
    if (props.minWidth == "auto") {
      holder.style.minWidth = "auto";
    } else {
      props.minWidth && (holder.style.minWidth = props.minWidth + "px");
    }

    // holder.style.minWidth = props.minWidth + 'px;'

    holder.classList.add("dark");

    document.body.appendChild(holder);

    let close = (e) => {
      if (!props.onClose) {
        holder.classList.remove("active");
        setTimeout(() => {
          holder.classList.remove("fadein");
          ReactDOM.unmountComponentAtNode(holder);
          holder.remove();
        }, 50);
        document.removeEventListener("mousedown", CleanRootNode, false);
        // e && e.stopPropagation()
        // e && e.preventDefault()
      } else {
        if (props.onClose(e) === !1) {
          holder.classList.remove("active");
          setTimeout(() => {
            holder.classList.remove("fadein");
            ReactDOM.unmountComponentAtNode(holder);
            holder.remove();
          }, 50);
          document.removeEventListener("mousedown", CleanRootNode, false);
          // e && e.stopPropagation()
          // e && e.preventDefault()
        }
      }
    };

    let CleanRootNode = (e) => {
      //为空 清理所有的弹出层
      if (BsyUtils.isObjectEmpty(window.MsgBubbleQueue)) {
        close(e);
        return;
      }

      // e 为null，组件自己清理自己
      let idex = window.MsgBubbleQueue.indexOf(rootTokenClass);
      if (!e) {
        close(e);
        window.MsgBubbleQueue.splice(idex, 1);
        return;
      }

      let clickindex = isClickDocument(e);
      // -1 说明点击了其他任意位置
      if (clickindex === -1) {
        close(e);
        window.MsgBubbleQueue = [];
      } else {
        //小于点击层的 都要关闭
        if (idex < clickindex) {
          close(e);
          window.MsgBubbleQueue.splice(idex, 1);
        }
      }
    };
    document.addEventListener("mousedown", CleanRootNode, false);

    const newProps = { ...props };
    if (newProps.onGetElement) {
      newProps.onGetElement(holder);
    }
    if (newProps.onGetContext) {
      newProps.onGetContext(newProps);
    }

    newProps.onRemoveRoot = (event) => {
      event && event.preventDefault();
      //自动清理
      CleanRootNode();
    };

    newProps.renderStyle = () => {
      let offset = BsyUtils.elemoffset(holder);
      if (offset.top < 0) {
        holder.style.top = 0 + "px";
        holder.style.bottom = "auto";
      } else {
        if (
          document.body.clientHeight <=
          offset.top + holder.offsetHeight + 10
        ) {
          //超出
          // console.log("超出界限")
          let top =
            offset.top - props.anchor.offsetHeight - 8 - holder.offsetHeight;
          if (top < 0) {
            top = 0;
          }
          holder.style.top = top + "px";
          // console.log("超出界限 " + holder.style.top)
        }
      }

      setTimeout(() => {
        holder.style.visibility = "";
        holder.classList.add("fadein");
        holder.classList.add("active");
      }, 30);
    };

    window.MsgBubbleContext[rootTokenClass] = newProps;

    ReactDOM.render(<Dlg {...newProps} />, holder);
  }).catch((res) => {
    console.error("BsyMsgBubble", res);
  });

export default BsyMsgBubble;
